<div class="ipm-verification-gate-modal">

  <!-- Icon -->
  <div class="check-section">
    <span class="icon">{{ icon }}</span>
  </div>

  <!-- Title -->
  <h2 class="ipm-modal-title">{{ title }}</h2>

  <!-- Description -->
  <p class="ipm-modal-desc" [innerHTML]="description"></p>

  <!-- CTA Buttons -->
  <div class="ipm-modal-actions">
    <button class="ipm-btn-primary" (click)="goToVerification()">Verify Now</button>
    <button class="ipm-btn-secondary" (click)="close()">Maybe Later</button>
  </div>

</div>
